import { FilterState, EntityType } from "./FilterBuilder.types";

const STORAGE_PREFIX = "filter_";

export const getStorageKey = (entityType: EntityType, pageId?: string): string => {
  return pageId 
    ? `${STORAGE_PREFIX}${entityType}_${pageId}`
    : `${STORAGE_PREFIX}${entityType}`;
};

export const saveFilter = (entityType: EntityType, filter: FilterState, pageId?: string): void => {
  try {
    const key = getStorageKey(entityType, pageId);
    localStorage.setItem(key, JSON.stringify(filter));
  } catch (error) {
    console.error("Error saving filter to localStorage:", error);
  }
};

export const loadFilter = (entityType: EntityType, pageId?: string): FilterState | null => {
  try {
    const key = getStorageKey(entityType, pageId);
    const stored = localStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored) as FilterState;
    }
  } catch (error) {
    console.error("Error loading filter from localStorage:", error);
  }
  return null;
};

export const clearFilter = (entityType: EntityType, pageId?: string): void => {
  try {
    const key = getStorageKey(entityType, pageId);
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error clearing filter from localStorage:", error);
  }
};






